export default class AvailabilityViewModel {
    key: string;
    value: string;
    public constructor(key: string, value: string) {
        this.key = key;
        this.value = value;
    }
}